import { render, staticRenderFns } from "./ListFeedback.vue?vue&type=template&id=25aacfa0&scoped=true&"
import script from "./ListFeedback.vue?vue&type=script&lang=ts&"
export * from "./ListFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./ListFeedback.vue?vue&type=style&index=0&id=25aacfa0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aacfa0",
  null
  
)

export default component.exports